<template>
  <div class="foreground d-flex align-items-center justify-content-center">
    <div class="playlist">
      <button
        class="red text-uppercase"
        data-toggle="modal"
        data-target="#buildPlaylistModal"
      >
        {{ $t("button.createPlaylist") }}
      </button>
      <Searching />
    </div>
    <build-playlist />
  </div>
</template>
<script>
import BuildPlaylist from "./BuildPlaylist";
import Searching from "./Searching";
export default {
  components: {
    BuildPlaylist,
    Searching,
  },
  data: () => ({
    searchText: "",
  }),
  watch: {
    searchText() {
      this.doSearch();
    },
  },
  methods: {
    doSearch() {
      this.$emit("onSearch", this.searchText);
    },
  },
};
</script>
<style lang="scss" scoped>
.foreground {
  background-image: url("../assets/img/home-landing.jpg");
  height: 600px;
  background-size: cover;
  button {
    letter-spacing: 1.5px;
  }
  @media (max-width: 1444px) {
    height: 500px;
  }
  @media (max-width: 1200px) {
    height: 400px;
  }
  @media (max-width: 768px) {
    height: 300px;
  }
}
</style>
